import { InventoryTransferCreatePage } from "./InventoryTransferCreatePage";
export default InventoryTransferCreatePage;
